<div class="card main-container">
    <h1>Form Events</h1>

    <div class="filter-container">
        <div class="grid row justify-content-between">
            <div class="col-10 col-10-padding">
                <filter #filter class="groups-filter" [settings]="filterSettings"></filter>
            </div>
            <div class="filter-add-button p-2">
                <button pButton  type="button" class="m-button-primary ml-10" label="Add Event" (click)="addEvent()"></button>
            </div>
        </div>
    </div>

    <grid #formEventsGrid [tableSettings]="tableSettings" [filter]="filter" [gridSettings]="gridSettings">
        <ng-template gridColumnTemplate="displayingRow" columnName="formEventUserType" let-formInfo>
            <div *ngIf="formInfo.formEventUserType.length > 1; else simpleUserTypeText"
                (mouseover)="showTagsOverlayPanel($event, formInfo.formEventUserType)"
                (mouseout)="hideTagsOverlayPanel($event)">
                Multiple
            </div>
            <ng-template #simpleUserTypeText>
                {{ getFirstUserType(formInfo.formEventUserType) }}
            </ng-template>
            <p-overlayPanel #userTypeOverlayPanel>
                <p-table [value]="overlayPanelItems" styleClass="p-datatable-striped">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{ overlayPanelTitle }}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>{{ item }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-overlayPanel>
        </ng-template>
    </grid>

    <p-dialog [(visible)]="showCreateEditDialog" *ngIf="showCreateEditDialog" [modal]="true" [draggable]="false"
        [header]="isCreate ? 'Create a Form Event' : 'Update Form Event'" appendTo="body"
        [style]="{ 'max-width': '450px', width: '100%' }">
        <form [formGroup]="formEventForm" autocomplete="off" class="inputs-group" [style.max-width]="'100%'">
            <div class="inputs-group pt-4">
                <div class="inputs-group-row" rte="fx">
                    <label class="inputs-group-row-name asterisk-mark" rte="fy">Event:</label>
                    <div class="inputs-group-row-value" rte="fz">
                        <p-dropdown 
                            placeholder="Select Event" 
                            [options]="eventOptions" 
                            [showClear]="true"
                            appendTo="body"
                            (onChange)= "eventChange($event.value)"
                            formControlName="eventType">
                        </p-dropdown>

                    </div>
                </div>

                <div class="inputs-group-row" rte="fN">
                    <label class="inputs-group-row-name asterisk-mark" rte="fO">User Types:</label>
                    <div class="inputs-group-row-value" rte="fP">
                        <p-multiSelect 
                            [options]="userTypeOptions" 
                            defaultLabel="Select User Types" 
                            appendTo="body"
                            [showClear]="true"
                            formControlName="userTypes">
                        </p-multiSelect>

                    </div>
                </div>
                <div class="inputs-group-row">
                    <label class="inputs-group-row-name ">Tags:</label>
                    <div class="inputs-group-row-value">
                        <p-multiSelect 
                            placeholder="Select Tags" 
                            [options]="tagOptions" 
                            (onChange)="onTagsChanged($event)"
                            (onClear)="onTagsChanged(null)"
                            [showClear]="true"
                            formControlName="tags" appendTo="body">
                        </p-multiSelect>
  
                    </div>
                </div>

                <div class="inputs-group-row">
                    <label class="inputs-group-row-name asterisk-mark">Form:</label>
                    <div class="inputs-group-row-value">
                        <p-dropdown #formDropdown 
                            [options]="definitionDropdownOptions"
                            [showClear]="true"
                            formControlName="formDefinition" 
                            appendTo="body" 
                            placeholder="Select Form">
                        </p-dropdown>
                      
                    </div>
                </div>

                <div class="inputs-group-row">
                    <div class="inputs-group-row-name">Mandatory:</div>
                    <div class="inputs-group-row-value">
                        <p-checkbox 
                            [binary]="true" 
                            formControlName="isMandatoryForm">
                         </p-checkbox>
                    </div>
                </div>
              <form-buttons  [disabled]="formEventForm.invalid" [config]="formButtonsConfig"></form-buttons>
            </div>
        </form>
    </p-dialog>
</div>